import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import CategoryCards from './components/CategoryCards';
import LatestNews from './components/LatestNews';
import PopularWorks from './components/PopularWorks';
import FAQSection from './components/FAQSection';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '安斋拉拉主题站',
  url: 'https://anzai-rara.com',
  description: '安斋拉拉官方主题落地页，汇聚最全作品、资料、动态与粉丝社区。',
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '安斋拉拉主题站',
  url: 'https://anzai-rara.com',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://anzai-rara.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webpageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '安斋拉拉 — 官方主题落地页',
  url: 'https://anzai-rara.com/',
  description: '深度解析安斋拉拉的故事、作品与影响力。汇聚最全作品合集、详尽资料档案、最新动态资讯。',
};

export default function Home() {
  return (
    <>
      <SEO
        title="安斋拉拉 — 官方主题落地页"
        description="深度解析安斋拉拉的故事、作品与影响力。汇聚安斋拉拉最全作品合集、详尽资料档案、最新动态资讯，以及粉丝社区互动。无论初次了解还是资深粉丝，这里带你全方位认识安斋拉拉的魅力与价值。"
        keywords="安斋拉拉,安斋拉拉作品,安斋拉拉资料,安斋拉拉最新动态,安斋拉拉粉丝,安斋拉拉介绍,安斋拉拉合集"
        canonicalUrl="https://anzai-rara.com/"
      />
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>

      <HeroSection />
      <CategoryCards />
      <LatestNews />
      <PopularWorks />
      <FAQSection />

      <section className="w-full py-16 md:py-20 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            加入安斋拉拉粉丝大家庭
          </h2>
          <p className="text-foreground-500 mb-8 leading-relaxed">
            第一时间获取最新动态，与全球粉丝一起分享热爱。订阅我们的资讯推送，不错过任何精彩内容。
          </p>
          <form
            data-readdy-form
            action="https://readdy.ai/api/form/d9q29rvnahb7382ov4u0"
            method="POST"
            className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 w-full sm:w-auto px-5 py-3 bg-background-100 border border-background-200 rounded-full text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即订阅
            </button>
            <div className="absolute opacity-0 pointer-events-none" aria-hidden="true">
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" readOnly />
            </div>
          </form>
        </div>
      </section>
    </>
  );
}